<template>
    <div class="d-flex w-full">
        <div v-if="needInit">{{initData()}}</div>
        <div v-if="getShowAnswerEvent">{{showAnswer()}}</div>
        <div v-if="getSaveCode">{{saveCode()}}</div>
        <div v-if="getResetTask">{{readOriginalProgram()}}</div>
        <div v-if="getCheckAnswerEvent">{{checkAnswer()}}</div>
        <div v-if="getRunCode == 2">{{runCode(2)}}</div>
       
        <div class="d-flex w-full shadow-none" v-if="loaded">
           <!--  <div>
                <v-layout row wrap> -->
                    <v-flex class="pa-0" :xs12="!showMyAnswer" :xs6="showMyAnswer" >
                        <v-tabs
                            center-active 
                            color="blue" slider-color="blue"
                            class="customTabTitle"
                            >
                            <v-tab v-for="(filename, index) in files.files" :key="index" @click="setActiveContent(index)">                                    
                                {{filename}} &nbsp;
                            </v-tab>
                        </v-tabs>
                        <codemirror @blur="saveCode()" class="border-top" ref="myCm1" v-model="mycontent.files[activeIndexFiles_files].rContent" 
                                        :options="getCmOptions()"
                                        >
                        </codemirror>
                    </v-flex>                                    
                    <v-flex v-if="showMyAnswer" xs6>
                        <h2>Answers:</h2>
                            <codemirror class="border-top" ref="myCm1" v-model="mycontent.files[activeIndexFiles_files].aContent" 
                                            :options="getCmOptions()"
                                            >
                            </codemirror>
                    </v-flex>
<!--                 </v-layout>            
            </div> -->
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import { codemirror } from 'vue-codemirror'
import axios from './../../axios-auth'
import {cyrillicToLatin} from './../../assets/misc'

import 'codemirror/lib/codemirror.js'
// language js
import 'codemirror/mode/javascript/javascript.js'
import 'codemirror/mode/css/css.js'
import 'codemirror/mode/xml/xml.js'
import 'codemirror/mode/htmlmixed/htmlmixed.js'
import 'codemirror/mode/python/python.js'
import 'codemirror/mode/sql/sql.js'
import 'codemirror/mode/php/php.js'
import 'codemirror/mode/clike/clike.js'

// language hint addons
import 'codemirror/addon/hint/show-hint.js'
import 'codemirror/addon/hint/show-hint.css'
import 'codemirror/addon/hint/javascript-hint.js'
import 'codemirror/addon/hint/css-hint.js'
import 'codemirror/addon/hint/xml-hint.js'
import 'codemirror/addon/hint/html-hint.js'
import 'codemirror/addon/hint/sql-hint.js'
import 'codemirror/addon/hint/anyword-hint.js'

// merge css
import 'codemirror/addon/merge/merge.css'
// merge js
import 'codemirror/addon/merge/merge.js'

export default {
    data() {
        return {
            showMyAnswer: false,
            showMyHelp: false,
            loaded : false,
            needInit: true,
            activeIndexFiles_files : 0, // content for active tab in files
            mycontent:  null,
            originalContent: null,
            original_files: null,
            files: null,
            mycode: 'hello world'
        }
    },    
    computed: 
        mapGetters([
                'getShowAnswerEvent',
                'getSaveCode',
                'getResetTask',   
                'getCheckAnswerEvent',
                'getRunCode'          
        ]),
    destroyed() {

    },
    props : {
            dcontent: Object,
            taskIndex: Number,
            activity_type: String
        },
    components: {
        codemirror     
    },
    mounted() {
        this.needInit = true
    },
    methods: {
        initData() {
            this.loaded = false
            this.needInit = false 
            this.originalContent = JSON.stringify(this.dcontent.data.content)
            this.mycontent = (this.dcontent.data.content)   

            this.grade = this.dcontent.score

            this.task_id = this.dcontent.task_id
            this.original_files = this.dcontent.data.globals.files
            this.files = this.original_files
            

            axios.post('/load-program3/' + this.task_id, {activity_type: this.activity_type}, this.$store.getters.getAxiosConfig )
            .then((res) => {
                // set data to var

                const data = (res.data.code == null) ? '' : res.data.code

                if (data.length > 2) {
                    const d = JSON.parse(data)                    
                    this.files.files = []
                    this.mycontent.files = []
                    for(let i = 0; i < d.length; i++) {                       
                        this.files.files.push(d[i].filename)
                        this.mycontent.files.push( {
                             rContent:  d[i].filecontent,
                             aContent: ''
                        })
                    }
                }
                this.loaded = true
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })
        },
        readOriginalProgram() {
            this.$store.commit('setResetTask',false)
            this.mycontent = JSON.parse(this.originalContent)
        },
        saveCode() {
            this.$store.commit('setSaveCode',false)
            var _d = []
            let _changed = false // new
            let _not_empty = false // new
            for(let i = 0; i<this.files.files.length; i++) {
                if (this.mycontent.files[i].rContent.trim() != '') _not_empty = true // new ak to zblbne a nenacita je to prazdne
                if (this.mycontent.files[i].rContent != JSON.parse(this.originalContent).files[i].rContent)  _changed = true // new
                _d.push( {
                    filename: this.files.files[i],
                    filecontent: this.mycontent.files[i].rContent
                })
            }

            if (_not_empty && _changed) { // new
                const data = {
                    task_id : this.task_id,
                    activity_type: this.activity_type,
                    files: JSON.stringify(_d),
                }
                // this.loaded = false // new toto som zrusil
                axios.post('/save-program3', data, this.$store.getters.getAxiosConfig )
                .then(() => {
                    // set data to var                
                    // this.loaded = true // new toto som zrusil
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })
            } else {
               // console.log('naprazdno')
            }

        },
        ///************************** */
        showAnswer() {
            this.$store.commit('setShowAnswerEvent', false)
           
            axios.get('/get-my-answer/'+this.dcontent.task_id, this.$store.getters.getAxiosConfig)
                .then((res) => {
                    this.useAnswer(res.data)
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })                                   
        },        
        useAnswer(myData) {
            const ac = JSON.parse(myData.answers)
            for(let i = 0; i < this.mycontent.files.length; i++) {                       
                this.mycontent.files[i].aContent = ac.files[i].aContent
            }
            this.$store.commit('setUserPerformance',myData.user)
            this.showMyAnswer = true // show code
        },    


        setActiveContent(index) {
            this.activeIndexFiles_files = index
        },

        runCode(_type) {
            const _run = _type - 1
            this.$store.commit('setRunCode',0)
            var submitted_files = []
            this.saveCode()
            this.$store.commit('setWaitingForResult',true) 

            for (let i=0; i<this.files.files.length; i++) {
                if (this.dcontent.task_type_id == 10) { // ; at the end of query 
                    var a = this.mycontent.files[i].rContent.trim()
                    if (a.length > 0)
                        if (a.substring(a.length-1) !=';') this.mycontent.files[i].rContent +=";"
                } 
                submitted_files.push( {
                    filename: this.files.files[i],
                    filecontent: this.mycontent.files[i].rContent
                })
            }
            let data = {
                task_id: this.task_id, //JSON.parsex(localStorage.getItem('position')).activeCourse.id,
                exe_type: _run, // 0 - evaluate, 1 - interactive
                submitted_files: cyrillicToLatin(JSON.stringify(submitted_files))
            }
           // console.log(data)
            axios.post('/vpl-run-test3', data, this.$store.getters.getAxiosConfig )
            .then((res) => {
                // pripravit tickety pre konzolu
                // console.log(res)
                this.$store.commit('setSocketTickets', res.data)
                this.$store.commit('setStartConsole', 1)
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })
        },
        checkAnswer() {
            this.$store.commit('setCheckAnswerEvent', false)
            this.runCode(1)  // !!!!!! evaluate code
        },
        getCmOptions() {
            return  {
                    tabSize: 4,
                    styleActiveLine: true,
                    lineNumbers: true,
                    line: true,
                    mode: this.$store.getters.getEditorType,
                    lineWrapping: false,
                    extraKeys: {'Ctrl-Space': 'autocomplete'}
                }
        }, 
    }
}
</script>
